import React from "react"
import types from "prop-types"
import { useSelector } from "react-redux"
import { useCustomName } from "hooks"
import { getFormQuestionTypeByUuid } from "reduxSlices/formBuilderSlice"
import { DEPARTMENT_KEY, FACILITY_KEY } from "utils/customNameHelpers"
import { operatorLabel } from "utils/QuestionBranching"
import { conditionOperators } from "Forms/FormElementTypes"
import { ListSelect } from "shared/selects"

const ConditionOperatorField = ({
  conditionQuestionUuid,
  setConditionOperator,
  value = null,
}) => {
  const conditionQuestionType = useSelector(getFormQuestionTypeByUuid(conditionQuestionUuid))

  const facility = useCustomName(FACILITY_KEY)
  const department = useCustomName(DEPARTMENT_KEY)

  if (!conditionQuestionType) return null

  const options = conditionOperators({ questionType: conditionQuestionType })

  const operatorsToOptions = (operators) => operators.map((operator) => ({
    label: operatorLabel(operator, { facility, department }),
    value: operator,
  }))

  return (
    <ListSelect
      className="text-sm mb-2"
      style={{ height: "32px", minWidth: "135px" }}
      options={options}
      optionsFromList={operatorsToOptions}
      value={value}
      onChange={setConditionOperator}
      backspaceDelete={false}
      label="select operator for condition"
    />
  )
}

ConditionOperatorField.propTypes = {
  conditionQuestionUuid: types.string.isRequired,
  setConditionOperator: types.func.isRequired,
  value: types.string,
}

export default ConditionOperatorField
